//
//
//
//
//
//
//
//

	export default {
		name: "loader",
        props: ['loader'],
	}
